import React, { useCallback } from 'react';
import useRouter from 'src/presentation/hooks/useRouter';
import { FullPageModal, CloseButtonTypes } from 'src/presentation/components/agent_desktop_components';

const DebuggerFlowPage = ({ root, content, dataAid }): JSX.Element => {
  const { match, history } = useRouter();

  const onClose = useCallback(() => {
    history.push(root);
  }, [history, root]);

  return (
    <FullPageModal
      closeButtonType={CloseButtonTypes.BACK_BUTTON}
      closeButtonLabel="Back to debugging home"
      content={content}
      data-aid={`${dataAid}-flow-modal`}
      onClose={onClose}
      visible={match != null}
      topPadding="0"
    />
  );
};

export default DebuggerFlowPage;
